export default "__VITE_ASSET__DqQlkwLy__"